import styled from '@emotion/styled';

export const Section = styled.section`
  margin-top: ${({ gapBefore }) => (gapBefore ? '1.5em' : 0)};
  margin-bottom: ${({ gapAfter }) => (gapAfter ? '1.5em' : 0)};
`;



// WEBPACK FOOTER //
// ./src/components/LE/Section.js